// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import AppInfoComponentResourceViewModel from '../../../../viewModel/resource/AppInfoComponentResourceViewModel';
import AppInfoComponentResourceDTO from '../../dto/resource/AppInfoComponentResourceDTO';

export default abstract class AppInfoComponentResourceModel extends BaseModel<AppInfoComponentResourceDTO> {
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get version() { return this.dto.version; }
  set version(value) { this.dto.version = value; }
  /**
  */
  get healthEndpoint() { return this.dto.healthEndpoint; }
  set healthEndpoint(value) { this.dto.healthEndpoint = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.title = qs.title;
    this.dto.version = qs.version;
    this.dto.healthEndpoint = qs.healthendpoint;
  }
}
